export default __webpack_public_path__ + "static/media/Landingpage Staking Coins.ee9c5310.mp4";